import pricingService from "@/services/pricingService";

export function calculateTax(data) {
  return pricingService({
    url: "/tax/calculateTax",
    method: "post",
    data,
  });
}